<template>
  <div class="content">
    <el-row :gutter="10" class="mb8">
      <el-col :span="6">
<!--        <el-menu default-active="0">-->
<!--          <el-menu-item index="0" @click="getList">-->
<!--            <span slot="title">全部</span>-->
<!--          </el-menu-item>-->
<!--          <el-menu-item v-for="item in typeOptions"-->
<!--                        :key="item.id" :index="item.id"-->
<!--                        @click="getList2(item.type)">-->
<!--            <span slot="title">{{item.type}}</span>-->
<!--          </el-menu-item>-->
<!--        </el-menu>-->
        <el-tree
            class="custom-tree"
            :data="typeOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            ref="tree"
            default-expand-all
            highlight-current
            @node-click="filterDataByType"
        />
      </el-col>
      <el-col :span="18">
        <el-row :gutter="10">
          <el-col :span="1.5">
            <el-button
                v-if="hasAddPermission"
                type="primary"
                plain
                icon="el-icon-plus"
                size="mini"
                @click="handleAdd"
            >新增佳作通报</el-button>
          </el-col>
          <el-col :span="1.5">
            <el-button
                v-if="hasDelPermission"
                type="danger"
                plain
                icon="el-icon-delete"
                size="mini"
                :disabled="multiple"
                @click="handleDelete2"
            >删除</el-button>
          </el-col>
        </el-row>

        <upload-excel v-if="hasAddPermission"  @getList="getList" />
<!--        <div v-for="(group, index) in groupedFilteredItems" :key="index" class="group">-->
<!--          <div v-for="item in group" :key="item.id" class="item-container">-->
<!--            <el-card shadow="always" class="box-card">-->
<!--              <div slot="header" class="clearfix">-->
<!--                <span class="title">{{ item.title }}</span>-->
<!--                <i class="el-icon-delete" style="float: right; padding: 3px 0" @click="del(item.id)"></i>-->
<!--              </div>-->
<!--              <span class="text1">作者</span>-->
<!--              <div class="text2">{{ item.author }}</div>-->
<!--              <span class="text1">供稿单位/部门</span>-->
<!--              <div class="text2">{{ item.company }}</div>-->
<!--            </el-card>-->
<!--          </div>-->
<!--        </div>-->
        <el-table
            v-loading="loading"
            :data="filteredItems"
            :default-sort="{prop: 'date', order: 'descending'}"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column label="标题" align="center" prop="title"  :show-overflow-tooltip="true" />
          <el-table-column label="获奖人" align="center" prop="author" :show-overflow-tooltip="true" />
          <el-table-column label="供稿单位/部门" align="center" prop="company" :show-overflow-tooltip="true" />
          <el-table-column label="榜单分类" align="center" prop="type" />
          <el-table-column label="上榜时间" align="center" prop="date" sortable />
          <el-table-column label="录入人" align="center" prop="recorder"  />
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-view"
                  @click="handleDetail(scope.row)"
              >查看详情</el-button>
              <el-button
                  v-if="hasUpdatePermission"
                  size="mini"
                  type="text"
                  icon="el-icon-edit"
                  @click="handleUpdate(scope.row)"
              >修改</el-button>
              <el-button
                  v-if="hasDelPermission"
                  size="mini"
                  type="text"
                  icon="el-icon-delete"
                  @click="del(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="width: 100%; margin: 10px 0">
          <el-pagination
              style="margin-top: 20px;text-align: right"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
        <el-dialog title="新增佳作" :visible.sync="open" width="60%" append-to-body>
          <el-row :gutter="15">
            <el-form ref="form" :model="form"
                     :rules="rules"
                     size="medium"
                     label-width="150px">
              <el-col :span="24">
                <el-form-item label="标题" prop="title">
                  <el-input v-model="form.title" placeholder="请输入标题" clearable :style="{width: '70%'}">
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="获奖人" prop="author">
                  <el-input v-model="form.author" placeholder="请输入获奖人" clearable :style="{width: '50%'}">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="供稿单位/部门" prop="company">
                  <el-input v-model="form.company" placeholder="请输入供稿单位/部门" clearable :style="{width: '50%'}">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="上榜日期" prop="date">
                  <el-date-picker
                      v-model="form.date"
                      type="date"
                      placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分类" prop="type">
<!--                  <el-select v-model="form.type"-->
<!--                             placeholder="请选择"-->
<!--                             :options="typeOptions"-->
<!--                             filterable-->
<!--                             :props="{ expandTrigger: 'hover' }"-->
<!--                             allow-create-->
<!--                             default-first-option>-->
<!--                    <el-option-->
<!--                        v-for="item in typeOptions"-->
<!--                        :key="item.id"-->
<!--                        :label="item.type"-->
<!--                        :value="item.type">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
                  <treeselect v-model="form.type" :options="typeOptions" :normalizer="normalizer" :disable-branch-nodes="true" placeholder="请选择分类" />
                </el-form-item>
              </el-col>

            </el-form>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
          </div>
        </el-dialog>
        <el-dialog
            title="详情"
            :visible.sync="open2"
            v-loading="loading"
            width="50%"
        >
          <p class="detail">标题：{{detail.title}}</p>
          <p class="detail">获奖人：{{detail.author}}</p>
          <p class="detail">供稿单位/部门：{{detail.company}}</p>
          <p class="detail">榜单分类：{{detail.type}}</p>
          <p class="detail">上榜时间：{{detail.date}}</p>
          <p class="detail">录入人：{{detail.recorder}}</p>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="open2 = false">确 定</el-button>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from "@/utils/request";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import UploadExcel from '@/components/UploadExcel.vue';
import {mapState} from "vuex";
// import userinfo from '@/utils/userinfo';


export default {
  name: "Masterpieces",
  components: {
    Treeselect,
    UploadExcel
  },
  data(){
    return {
      loading: false,
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      type: '',
      userInfo: {},
      filteredItems: [],
      typeOptions: [{
        label: "全部",
        children: [{
          label: "日榜",
          children: [{
            label: '端内流量日榜',
          },
            {
              label: '全网传播日榜',
            }]
        },
          {
            label: "周榜",
            children: [{
              label: '端内流量周榜',
            }]
          },
          {
            label: "月榜",
            children: [{
              label: '端内流量月榜',
            },
              {
                label: '全网传播月榜',
              },
              {
                label: '直播、活动传播力特别奖',
              }]
          },
          {
            label: "月度新闻奖",
          },
          {
            label: "大众新闻奖",
          }]
      }],
      defaultProps: {
        children: "children",
        label: "label"
      },
      list: [],
      open: false,
      open2: false,
      detail: {},
      form: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      sortProp: 'date',
      sortOrder: 'descending',
      rules: {
        title: [
          { required: true, message: "标题不能为空", trigger: "blur" }
        ],
        author: [
          { required: true, message: "获奖人不能为空", trigger: "change" }
        ],
        company: [
          { required: true, message: "供稿单位/部门不能为空", trigger: "change" }
        ],
        type: [
          { required: true, message: "分类不能为空", trigger: "change" }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasAddPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_report_add');
    },
    hasDelPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_report_del');
    },
    hasUpdatePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_report_update');
    },
  },
  mounted() {
    // 禁止右键
    document.addEventListener('contextmenu', this.preventRightClick);
    // 禁止选择
    document.addEventListener('selectstart', this.preventSelection);
  },
  beforeDestroy() {
    // 移除事件监听器，防止内存泄漏
    document.removeEventListener('contextmenu', this.preventRightClick);
    document.removeEventListener('selectstart', this.preventSelection);
  },
  created() {
    this.getList();
  },
  methods: {
    preventRightClick(event) {
      event.preventDefault();
    },
    preventSelection(event) {
      event.preventDefault();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleSortChange({ prop, order }){
      this.sortProp = prop;
      this.sortOrder = order;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    normalizer(node) {
      return {
        id: node.id || node.label,
        label: node.label,
        children: node.children,
      };
    },
    getList(){
      this.loading = true;
      request.get('/masterpieces/getList',{
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          sortProp: this.sortProp,
          sortOrder: this.sortOrder,
          type: this.type
        }
      }).then(res =>{
        this.list = res.data.records;
        this.filteredItems = res.data.records;
        this.total = res.data.total
        this.loading = false;
      })
    },
    getList2(e){
      this.loading = true;
      this.type = e;
      request.get('/masterpieces/getList',{
        params: {
          type: this.type,
        }
      }).then(res =>{
        this.list = res
        this.loading = false;
      })
    },

    handleAdd() {
      this.form.id = undefined
      this.open = true;
      this.resetForm("form");
    },
    handleDetail(row) {
      this.loading = true;
      this.detail = JSON.parse(JSON.stringify(row));
      this.open2 = true
      this.loading = false
    },
    // submitForm() {
    //   request.post('/masterpieces/add',this.form).then(response => {
    //     this.$message({
    //       message: '添加成功',
    //       type: 'success'
    //     });
    //     console.log(this.form)
    //     this.open = false;
    //     this.getList();
    //   });
    // },
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 克隆一份表单数据
          const formData = JSON.parse(JSON.stringify(this.form));
          formData.recorder = this.user.userName
          if (formData.date) {
            const utcDate = new Date(formData.date); // 从表单中获取时间

            // 加上8小时
            utcDate.setHours(utcDate.getHours() + 16);
            formData.date = utcDate.toISOString(); // 转换为 ISO 格式字符串
          }
          // console.log(formData)
          // 将管理员数组转换成字符串
          // formData.administrators = formData.administrators.join(', ');
          if (formData.id !== undefined) {
            request.put('/masterpieces/update', formData).then(res => {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.open = false;
              this.getList();
            });
          } else {
            request.post('/masterpieces/add', formData).then(response => {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    cancel() {
      this.open = false;
    },
    handleUpdate(row) {
      const id = row.id;
      // 深拷贝避免引用问题
      this.form = JSON.parse(JSON.stringify(row));
      // 回显多选管理员
      // this.form.administrators = row.administrators ? row.administrators.split(', ') : [];
      this.open = true;
      this.title = "修改信息";
    },
    del(e){
      const id = e.id
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete('/masterpieces/delete/' + id).then(res=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDelete2() {
      if (this.ids.length === 0) {
        this.$message({
          type: 'info',
          message: '请选择要删除的项'
        });
        return;
      }
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteBatch(this.ids);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteBatch(ids) {
      request.post('/masterpieces/deleteBatch', ids)
          .then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList(); // 重新获取列表
          })
          .catch(error => {
            console.error(error);
            this.$message({
              type: 'error',
              message: '删除失败'
            });
          });
    },
    // filterDataByType(node) {
    //   if (node.label === '全部') {
    //     this.filteredItems = this.list; // 显示所有数据
    //   } else if (node.children && node.children.length > 0) {
    //     const childLabels = node.children.map(child => child.label);
    //
    //     // Filter items that match the parent label or any child label
    //     this.filteredItems = this.list.filter(item =>
    //         item.type === node.label || childLabels.includes(item.type)
    //     );
    //   } else {
    //     // For a child node, only match the exact label
    //     this.filteredItems = this.list.filter(item => item.type === node.label);
    //   }
    // },
    filterDataByType(node) {
      this.type = node.label === '全部' ? '' : node.label;
      this.getList();
    },
  }
}
</script>

<style>
.content{
  margin: 20px;
}
.group {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.box-card{
  width: 300px;
  height: 300px;
}
.el-card .el-card__header {
  background-image: linear-gradient(to right, #f83600 0%, #f9d423 100%); /* 使用 !important 强制应用 */
}
.item-container {
  margin: 10px;
}
.title{
  color: white;
  font-weight: bold;
}
.text1 {
  color: white;
  font-weight: bold;
  padding: 10px;
  background-color: red;
}
.text2 {
  margin: 20px 10px;
}
.custom-tree .el-tree-node__label {
  font-size: 16px; /* 设置为你想要的字体大小 */
}
</style>